import React, { useCallback } from 'react'
import { hooks, I18n } from '@front/volcanion/'
import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'

import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const VoucherSection = ({ record_id, enableSubmitAll }) => {
  const [, { openDialog }] = hooks.useDialogs()

  const formToFilter = useCallback((values) => _.merge({}, values, { companyservice: { contract: { company: record_id } } }), [record_id])
  const onAddClick = useCallback(() => openDialog('voucher'), [openDialog])
  const onRowClick = useCallback((voucher_id) => openDialog('voucher_list', { voucher_id }, { voucher_id }), [openDialog])


  return <>
    <StepLabel>
      <Typography variant='h5'>{I18n.t('voucher.label')}</Typography>
    </StepLabel>
    <StepContent>
      <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
        <SearchFrame
          model_name={'voucher'}
          populate={['createdBy.info']}
          createButtonProps={{
            label: I18n.t('voucher.add'),
            onClick: onAddClick
          }}
          sort={['createdAt DESC']}
        >
          <SearchForm
            formToFilter={formToFilter}
            submitOnMount
            disableButton
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            formProps={{
              disableParentSubmitListener: true,
              closeOnSuccess: true,
              submitChangesOnly: false
            }}
            formActionsProps={{
              enableSubmitAll
            }}
            tableProps={{
              onRowClick,
              allowEditMode: true,
              allowRowGenerate: false,
              allowRowDelete: false,
              enablePagination: true,
              enableRowActions: true,
              enableGlobalActions: true
            }}
          >
            <TableHeader><Header /></TableHeader>
            <TableRow><Row company={record_id} /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Box>
    </StepContent>
  </>
}

export default React.memo(VoucherSection)
